import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { useContext, useEffect, useState, useCallback } from "react";

// @mui material components
import {
  Box,
  Card,
  Chip,
  CircularProgress,
  createFilterOptions,
  Fade,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tooltip,
  Autocomplete,
  TextField,
} from "@mui/material";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";
import { getUproColor } from "utils/colors";
import { validateCUIL, validateDNI } from "utils/validations";
import { useApolloClient } from "context/apolloClientContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "70%", xxl: "50%" },
  overflow: "auto",
  p: 3,
};

const SAVE_CONVENIO = gql`
  mutation saveConvenio($input: ConvenioInput!) {
    saveConvenio(input: $input) {
      id
    }
  }
`;

export default function ModalAdd({ open, handleClose, data, refetch }) {
  const [convenio, setConvenio] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const { handleSnackbar } = useContext(MessageManager);

  const [saveConvenio, { loading }] = useMutation(SAVE_CONVENIO, {
    onCompleted: () => {
      handleSnackbar("Convenio guardado correctamente", "success");
      refetch();
      handleClose();
    },
    onError: (error) => {
      handleSnackbar(error.message, "error");
    },
  });

  useEffect(() => {
    if (data) {
      setConvenio(data);
      setIsEditing(true);
    } else {
      setConvenio();
      setIsEditing(false);
    }
  }, [data]);
  const handleSave = () => {
    if (isEditing) {
      saveConvenio({
        variables: { input: { nombreInstitucion: convenio.nombreInstitucion, id: convenio.id } },
      });
      return;
    } else {
      saveConvenio({ variables: { input: convenio } });
    }
  };
  const handleChange = (e) => {
    setConvenio({ ...convenio, [e.target.name]: e.target.value });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between" mb={2}>
              <SoftBox>
                <SoftTypography variant="h6">
                  {isEditing ? "Editar convenio" : "Agregar convenio"}
                </SoftTypography>
              </SoftBox>
            </SoftBox>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <InputLabel>
                  <SoftTypography variant="caption">Nombre de la institución</SoftTypography>
                </InputLabel>
                <SoftInput
                  label="Nombre"
                  name="nombreInstitucion"
                  value={convenio?.nombreInstitucion || ""}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
            </Grid>
            <SoftBox
              display="flex"
              justifyContent="end"
              mt={2}
              gap={1}
              flexDirection={{ xs: "column", sm: "row" }}
            >
              <SoftButton color="uproGreen" circular onClick={handleClose} disabled={loading}>
                <Icon sx={{ fontWeight: "light" }}>close</Icon>
                &nbsp;Cerrar
              </SoftButton>
              <SoftButton
                color="primary"
                circular
                onClick={handleSave}
                disabled={loading || !convenio?.nombreInstitucion}
              >
                <Icon sx={{ fontWeight: "light" }}>save</Icon>
                &nbsp;Guardar
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalAdd.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  data: PropTypes.object,
  refetch: PropTypes.func,
};
